import React from "react";
import HseThresholdMetric from "./HseThresholdMetric";
import { Error, Loader } from "./common";
import { overviewChartPalette } from "styles/theme";

const StopWorkAgeing = ({ numberOfStopWorkOrders, isLoading, isError }) => {
    if (isLoading) return <Loader isLoading={isLoading} />;
    if (isError) return <Error isError={isError} />;
    const value = Number(numberOfStopWorkOrders) || 0;
    const onTarget = value === 0;
    const color = onTarget ? overviewChartPalette.teal : overviewChartPalette.coral;
    return <HseThresholdMetric eyebrow="Critical control" title="Stop-Work Notices" subtitle="Tracks serious breaches requiring immediate work suspension." value={value} status={onTarget ? "On target" : "Immediate action"} color={color} progress={onTarget ? 0 : 100} benchmark="Target 0 active stop-work notices" />;
};

export default StopWorkAgeing;
